export default __webpack_public_path__ + "static/media/bg_battle_hd.56bccb6e.webp";